import React from 'react';

const RequisitosSection = ({ renderSeccion, renderCheckbox, renderFormularioMateria, renderListaMaterias }) => (
  <>
    {renderSeccion('Requisitos Generales', (
      <div>
        {renderCheckbox('constitucional', 'Constitucional Profundizado', 4)}
        {renderCheckbox('integracion', 'Integración', 4, 'Requiere todas las materias del CPC y las 5 materias obligatorias del CPO')}
        <div style={{ marginTop: '15px' }}>
          <h4 style={{ color: 'var(--text-primary)', marginBottom: '10px' }}>Departamento de Filosofía (4 puntos)</h4>
          {renderFormularioMateria('filosofia', 4)}
          {renderListaMaterias('filosofia', 'Materias de Filosofía Cursadas')}
        </div>
        <div style={{ marginTop: '15px' }}>
          <h4 style={{ color: 'var(--text-primary)', marginBottom: '10px' }}>Departamento de Sociales (4 puntos)</h4>
          {renderFormularioMateria('sociales', 4)}
          {renderListaMaterias('sociales', 'Materias de Sociales Cursadas')}
        </div>
      </div>
    ))}

    {renderSeccion('Área Procesal (6 puntos)', (
      <div>
        {renderCheckbox('metodos', 'Métodos Alternativos de Resolución de Conflictos', 2)}
        {renderCheckbox('concursos', 'Concursos', 2)}
        <div style={{ marginTop: '15px' }}>
          <h4 style={{ color: 'var(--text-primary)', marginBottom: '10px' }}>Materias Libres (2 puntos)</h4>
          {renderFormularioMateria('procesalLibre', 2)}
          {renderListaMaterias('procesalLibre', 'Materias Procesales Libres Cursadas')}
        </div>
      </div>
    ))}

    {renderSeccion('Requisitos Finales', (
      <div>
        {renderCheckbox('practico', 'Práctico Profesional', 19, 'Requiere todas las materias del CPC, las 5 materias obligatorias del CPO y los 20 puntos de la sección "Principales"')}
        {renderCheckbox('lectocomprension', 'Lecto-comprensión en Idioma Extranjero', 0, 'Requiere todas las materias del CPC y tres de las cinco materias obligatorias del CPO')}
      </div>
    ))}
  </>
);

export default RequisitosSection;
